// extracted by mini-css-extract-plugin
export default {"giftPointBody":"CustomerInfo_giftPointBody__PN5xn","okBtn":"CustomerInfo_okBtn__6hCUB"};